import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import { User, LeaderboardEntry, IUser } from 'protos'
import useInterval from 'hooks/useInterval'

import GameChat, { GameChatComment } from 'components/GameChat'
import GameChatBar from 'components/GameChat/components/GameChatBar'
import GameChatMessage from 'components/GameChat/components/GameChatMessage'
import GameChatInput from 'components/GameChat/components/GameChatInput'

const sampleUsers = [
  User.create({
    userId: 'user1',
    name: 'John Doe',
    photoUrl: 'http://i.pravatar.cc/64?img=1',
  }),
  User.create({
    userId: 'user2',
    name: 'Jane Doe',
    photoUrl: 'http://i.pravatar.cc/64?img=2',
  }),
  User.create({
    userId: 'user3',
    name: 'Mike Doe',
    photoUrl: 'http://i.pravatar.cc/64?img=3',
  }),
]

storiesOf('GameChat', module)
  .add('inactive', () => {
    return (
      <GameChat
        comments={[]}
        ownUserId={sampleUsers[0].userId}
        leaderboard={sampleUsers.map(user => LeaderboardEntry.create({ user }))}
        onSend={action('onSend')}
      />
    )
  })
  .add('active, without comments', () => {
    return (
      <GameChat
        active
        comments={[]}
        ownUserId={sampleUsers[0].userId}
        leaderboard={sampleUsers.map(user => LeaderboardEntry.create({ user }))}
        onSend={action('onSend')}
      />
    )
  })
  .add('active, with comments', () => {
    const SimulatedGameChat = () => {
      const [comments, setComments] = React.useState<GameChatComment[]>([
        {
          from: sampleUsers[0].userId,
          ts: +new Date(),
          msg: 'This is a quite long message, but it should not matter.',
        },
        {
          from: sampleUsers[1].userId,
          ts: +new Date(),
          msg: `Okay **${sampleUsers[0].name}**. This is a reply with a mention!`,
        },
        {
          from: sampleUsers[2].userId,
          ts: +new Date(),
          msg: 'Nice!',
        },
      ])

      const appendMessage = (from: IUser, message: string) => {
        setComments([...comments, { from: from.userId!, ts: +new Date(), msg: message }])
      }

      useInterval(() => {
        const randomStranger = sampleUsers[1 + Math.floor(Math.random() * (sampleUsers.length - 1))]
        appendMessage(randomStranger, 'This is a sample comment.')
      }, 2500)

      return (
        <GameChat
          active
          comments={comments}
          ownUserId={sampleUsers[0].userId}
          leaderboard={sampleUsers.map(user => LeaderboardEntry.create({ user }))}
          onSend={text => appendMessage(sampleUsers[0], text)}
        />
      )
    }

    return <SimulatedGameChat />
  })

storiesOf('GameChat/GameChatBar', module)
  .add('inactive', () => (
    <GameChatBar />
  ))
  .add('active, closed, without comments', () => (
    <GameChatBar active />
  ))
  .add('active, closed, with comments', () => (
    <GameChatBar active numComments={99} />
  ))
  .add('active, opened, with comments', () => (
    <GameChatBar active numComments={99} open />
  ))

storiesOf('GameChat/GameChatMessage', module)
  .add('outgoing', () => (
    <GameChatMessage
      user={sampleUsers[0]}
      timestamp={+new Date()}
      message="Lorem ipsum"
    />
  ))
  .add('incoming', () => (
    <GameChatMessage
      incoming
      user={sampleUsers[1]}
      timestamp={+new Date()}
      message="Lorem ipsum"
      onMention={action('onMention')}
    />
  ))

storiesOf('GameChat/GameChatInput', module)
  .add('default', () => {
    const ControlledGameChatInput = () => {
      const [text, setText] = React.useState('')
      return <GameChatInput text={text} setText={setText} onSend={action('onSend')} />
    }

    return <ControlledGameChatInput />
  })
